var _defs, _path, _g, _g2, _path2, _g3, _g4, _g5, _path3, _g6, _path4, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotEnoughMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7169",
    "data-name": "Rectangle 7169",
    width: 380,
    height: 160,
    transform: "translate(531 220)",
    fill: "#f0e4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Not_enough_money_in_your_account",
    "data-name": "Not enough money in your account",
    transform: "translate(-531 -220)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28810",
    "data-name": "Group 28810",
    transform: "translate(0.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28807",
    "data-name": "Group 28807",
    transform: "translate(647.543 227.125) rotate(21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13149",
    "data-name": "Group 13149",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13148",
    "data-name": "Group 13148",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_176",
    "data-name": "Union 176",
    d: "M.109,18.834C-.657,11.622,2.673,5.42,8.076,2.744L13.618,0c-5.4,2.676-8.734,8.878-7.967,16.09,1.025,9.637,8.975,17.428,17.757,17.4l-5.543,2.745,5.543-2.743a13.729,13.729,0,0,0,6.081-1.409l-5.543,2.744a13.7,13.7,0,0,1-6.081,1.408h-.045C9.057,36.237,1.131,28.455.109,18.834Z",
    transform: "translate(0.289 6.876)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13147",
    "data-name": "Group 13147"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 15.514,
    cy: 17.893,
    rx: 15.514,
    ry: 17.893,
    transform: "translate(0 13.768) rotate(-26.343)",
    fill: "#94c1ea"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13938",
    "data-name": "Group 13938",
    transform: "translate(698.983 304.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24619",
    "data-name": "Path 24619",
    d: "M-4649.943-6677.994l10.081,5.823.034-11.429-.237-.131Z",
    transform: "translate(4649.943 6683.731)",
    fill: "#121b45"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_186",
    "data-name": "Union 186",
    d: "M16.93,75.438l9.876-5.74L9.876,93.49,0,99.23ZM6.844,69.618l8.375-4.87L13.092,65.98,6.846,69.606l.04-11.416L7.031,5.748,16.9,0h.014l-.184,63.871-.006,0L26.8,69.7l-9.878,5.742Z",
    transform: "translate(715.733 254.566)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28600",
    "data-name": "Group 28600",
    transform: "translate(698.984 246.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13943",
    "data-name": "Group 13943",
    transform: "translate(0 5.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32238",
    "data-name": "Path 32238",
    d: "M-4616.265-6646.192-4633.2-6622.4l-16.747-43.235,10.082,5.813v.012h.013l.027-11.43.144-52.439,13.512,7.8-.144,52.44-.041,11.418v.014Z",
    transform: "translate(4649.942 6723.68)",
    fill: "#4972f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13942",
    "data-name": "Group 13942",
    transform: "translate(10.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M-4618.717-6720.271l-9.872,5.747-13.513-7.8,9.886-5.735Z",
    transform: "translate(4642.103 6728.061)",
    fill: "#f4f7fe"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28601",
    "data-name": "Group 28601",
    transform: "translate(742.542 271.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19823",
    "data-name": "Group 19823",
    transform: "translate(0 2.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13944-2",
    "data-name": "Group 13944-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13938-2",
    "data-name": "Group 13938-2",
    transform: "translate(0 57.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24619-2",
    "data-name": "Path 24619-2",
    d: "M-4616.676-6657.978l10.082,5.821.033-11.428-.239-.132Z",
    transform: "translate(4616.676 6663.716)",
    fill: "#121b45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_187",
    "data-name": "Union 187",
    d: "M16.928,82.189l9.878-5.743L9.876,100.236,0,105.976ZM6.844,76.364l0,0H6.839l.027-5.695v-.013l.012-5.722L6.9,56.789l.117-45.344.027.013,9.845-5.724-.169,64.89,10.08,5.82-9.878,5.741ZM7.048.013V0l.025.027Z",
    transform: "translate(16.749)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13943-2",
    "data-name": "Group 13943-2",
    transform: "translate(0.005 3.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M-4582.995-6625.926l-3.09,4.347-1.729,2.422-12.1,17.008-16.76-43.222,10.083,5.813.025-11.418.184-53.487,13.473,7.791.025.012-.143,45.331-.026,8.145-.013,5.721v.014l-.013,5.683v.013Z",
    transform: "translate(4616.672 6704.461)",
    fill: "#4972f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13942-2",
    "data-name": "Group 13942-2",
    transform: "translate(10.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32243",
    "data-name": "Path 32243",
    d: "M-4585.465-6701.064v.039l-9.847,5.722-.026-.013-13.473-7.791,9.872-5.734,3.627,2.093.026.014h.013Z",
    transform: "translate(4608.811 6708.84)",
    fill: "#f4f7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32244",
    "data-name": "Path 32244",
    d: "M-4590.982-6702.859v-.052l.04.025Z",
    transform: "translate(4614.329 6710.676)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28602",
    "data-name": "Group 28602",
    transform: "translate(655 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19823-2",
    "data-name": "Group 19823-2",
    transform: "translate(0 5.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13944-2-2",
    "data-name": "Group 13944-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13938-2-2",
    "data-name": "Group 13938-2-2",
    transform: "translate(0 53.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24619-2-2",
    "data-name": "Path 24619-2-2",
    d: "M-4683.534-6697.643l10.082,5.82.03-11.426-.238-.132Z",
    transform: "translate(4683.534 6703.38)",
    fill: "#121b45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_188",
    "data-name": "Union 188",
    d: "M16.934,76.444,26.809,70.7,9.876,94.494,0,100.237ZM6.844,70.625l.008,0v-.005l.013-5.7.027-5.724L6.9,51.053,7.023,5.7l.027.013L16.9,0l-.171,64.878v0L26.8,70.7l-9.876,5.743Z",
    transform: "translate(16.746 2.07)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13943-2-2",
    "data-name": "Group 13943-2-2",
    transform: "translate(0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32247",
    "data-name": "Path 32247",
    d: "M-4649.858-6665.6l-3.1,4.347-1.716,2.422-12.1,17.009-16.748-43.209v-.013l10.07,5.8.012.013.027-11.417.184-53.462,13.46,7.765.025.013-.144,45.343-.026,8.145-.013,5.722-.014,5.7h.014l10.055,5.827Z",
    transform: "translate(4683.522 6744.112)",
    fill: "#4972f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13942-3",
    "data-name": "Group 13942-3",
    transform: "translate(10.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32248",
    "data-name": "Path 32248",
    d: "M-4652.329-6740.735v.054l-9.846,5.708-.027-.014-13.46-7.764v-.026l9.859-5.735Z",
    transform: "translate(4675.676 6748.512)",
    fill: "#f4f7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32249",
    "data-name": "Path 32249",
    d: "M-4675.672-6744.118l.014-.013v.026Z",
    transform: "translate(4675.672 6749.867)",
    fill: "#f4f7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32250",
    "data-name": "Path 32250",
    d: "M-4657.8-6742.546l-.038.027v-.052Z",
    transform: "translate(4681.188 6750.349)",
    fill: "#f4f7fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28808",
    "data-name": "Group 28808",
    transform: "translate(718.616 285.572) rotate(-98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19512",
    "data-name": "Group 19512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19425",
    "data-name": "Group 19425",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19424",
    "data-name": "Group 19424",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Union_179",
    "data-name": "Union 179",
    d: "M12.7.61C5.81,2.368,1.244,7.548.63,13.431L0,19.465C.615,13.581,5.18,8.4,12.072,6.643c9.211-2.35,19.092,2.3,22.068,10.383l.63-6.033C32.317,4.33,25.173,0,17.581,0A19.713,19.713,0,0,0,12.7.61ZM34.14,17.026a13.46,13.46,0,0,1,.783,6.071l.63-6.033a13.457,13.457,0,0,0-.783-6.071Z",
    transform: "translate(1.575 0)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19423",
    "data-name": "Group 19423",
    transform: "translate(0 4.323)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2922",
    "data-name": "Ellipse 2922",
    cx: 17.551,
    cy: 15.217,
    rx: 17.551,
    ry: 15.217,
    transform: "translate(3.161 0) rotate(5.962)",
    fill: "#53ae94"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28809",
    "data-name": "Group 28809",
    transform: "matrix(-0.454, 0.891, -0.891, -0.454, 806.96, 315.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13081",
    "data-name": "Group 13081",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13080",
    "data-name": "Group 13080",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Union_173",
    "data-name": "Union 173",
    d: "M7.351,3.422C1.489,7.41-1.033,13.812.387,19.536L1.844,25.4C.424,19.68,2.945,13.277,8.808,9.29c7.834-5.329,18.672-4.325,24.2,2.242h0a13.4,13.4,0,0,1,2.793,5.425L34.35,11.091a13.412,13.412,0,0,0-2.794-5.424v0A16.9,16.9,0,0,0,18.518,0,19.924,19.924,0,0,0,7.351,3.422Z",
    transform: "translate(1.807 0)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13079",
    "data-name": "Group 13079",
    transform: "translate(0 2.246)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 15.167,
    cy: 17.494,
    rx: 15.167,
    ry: 17.494,
    transform: "matrix(0.241, 0.971, -0.971, 0.241, 33.957, 0)",
    fill: "#ffb063"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEnoughMoney);
export default __webpack_public_path__ + "static/media/notEnoughMoney.8e764288cc4733647e54554cb704752f.svg";
export { ForwardRef as ReactComponent };